import React, { useState, forwardRef, ReactElement } from 'react';
import { View, TextInput, TextInputProps, StyleProp, ViewStyle } from 'react-native';
import { useTheme } from '@pulsar/core';
import { Hoverable } from 'src/components/Hoverable';
import useStyles from './TextField.styles';

export type TextFieldProps = TextInputProps & {
  disabled?: boolean;
  error?: boolean;
  success?: boolean;
  icon?: ReactElement;
  rootStyle?: StyleProp<ViewStyle>;
};

export const TextField = forwardRef<TextInput, TextFieldProps>(
  ({ disabled, error, success, icon = undefined, rootStyle, style, ...props }, ref) => {
    const [hovered, toggleHover] = useState(false);
    const [focused, toggleFocus] = useState(false);
    const theme = useTheme();
    const s = useStyles();

    return (
      <Hoverable
        onHoverIn={() => !disabled && toggleHover(true)}
        onHoverOut={() => !disabled && toggleHover(false)}
      >
        <View
          style={[
            s.root,
            disabled && s.disabled,
            hovered && s.hovered,
            focused && s.focused,
            error && s.error,
            success && s.success,
            rootStyle,
          ]}
        >
          {icon &&
            React.cloneElement(icon, {
              style: [s.icon, focused && s.iconActive],
            })}
          <TextInput
            {...props}
            ref={ref}
            style={[s.input, icon && s.withIcon, style]}
            editable={!disabled}
            placeholderTextColor={theme.colors.formFieldPlaceholder}
            onFocus={() => !disabled && toggleFocus(true)}
            onBlur={() => !disabled && toggleFocus(false)}
          />
        </View>
      </Hoverable>
    );
  }
);
